import { render, staticRenderFns } from "./CompanyGroupDialog.vue?vue&type=template&id=6c2225e7&scoped=true"
import script from "./CompanyGroupDialog.vue?vue&type=script&lang=js"
export * from "./CompanyGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyGroupDialog.vue?vue&type=style&index=0&id=6c2225e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2225e7",
  null
  
)

export default component.exports